export default {
"pdf-eop-account": "Account",
"pdf-eop-amount-approved": "Approved",
"pdf-eop-amount-submitted": "Submitted",
"pdf-eop-appeal-rights"                         : "Appeal Rights",
"pdf-eop-appeal-rights-description"             : "If you have questions on how your claim was processed please review our important claims processing information and your complaint/appeal filing rights.",
"pdf-eop-claim-number"                          : "Claim #",
"pdf-eop-claim-summary"                         : "Claim Summary",
"pdf-eop-claims"                                : "Individual Claims",
"pdf-eop-denial-adjustment-reason"              : "Reason",
"pdf-eop-explanation-of-payment"                : "Explanation of Payment",
"pdf-eop-not-applicable"                        : "N/A",
"pdf-eop-patient"                               : "Patient",
"pdf-eop-payee"                                 : "Payee",
"pdf-eop-payment-issue-date"                    : "Payment Issue Date",
"pdf-eop-payment-type"                          : "Payment Type",
"pdf-eop-service-from-date"                     : "Service From",
"pdf-eop-service-to-date"                       : "Service To",
"pdf-eop-service-type"                          : "Service Type",
"pdf-eop-source"                                : "Source",
"pdf-eop-summary"                               : "Payment Summary",
"pdf-eop-total-paid"                            : "Total Paid",

// // General
"pdf-general-account": "Account:",
"pdf-general-amount": "Amount",
"pdf-general-available-balance": "Available Balance:",
"pdf-general-page-footer": "&nbsp;",
"pdf-general-participant": "Participant:",
"pdf-general-posted": "Posted",
"pdf-general-tax-year": "Tax Year",
"pdf-general-transaction": "Transaction",

// Statement
"pdf-statement-brand-name"                      : "Further",
"pdf-statement-main-website"                    : "https://www.hellofurther.com",
"service-mark"                                  : "",
"pdf-statement-title"                           : "Member Account Statement",
"pdf-statement-thank-you-message"               : "Thank you for being a valued customer of %groupBrandName%. ",
"pdf-statement-range-message"                   : "This account summary is being provided to reflect all account activity processed on your account from %startDate% through %endDate%. ",
"pdf-statement-tax-year-message"                : "This account summary is being provided to reflect all account activity processed on your account during the %taxYear% tax year. ",
"pdf-statement-visit-our-website-message"       : "Please visit our website at %groupMainSiteURL% for detailed account activity throughout the year, including available balance, payments and claim information.",
"pdf-statement-employer"                        : "Employer:",
"pdf-statement-sa-id"                           : "SA ID:",
"pdf-statement-date"                            : "Date:",
"pdf-statement-please-note"                     : "Please note the following:",
"pdf-statement-claims-no-grace"                 : "Claims must be incurred during the plan year in order to be considered for payment from your account.",
"pdf-statement-claims-grace-period"             : "Claims must be incurred during the plan year or the grace period in order to be considered for payment from your account.",
"pdf-statement-hra-or-fsa-note"                 : "If there is a termination date on your account, expenses must be incurred prior to the termination date to be eligible for reimbursement. Please see your summary plan description for more information. Claims must be received on or by the claims filing deadline to be eligible for reimbursement.",
"pdf-statement-investment-message"              : "This summary does not include your investment account balance. Visit our website for investment account information.",
"pdf-statement-can-open-investment-account"     : "Your Base Balance is over $%threshold% - you now qualify for an investment account. To open an investment account, or for more information, please visit our website.",
"pdf-statement-cannot-open-investment-account"  : "As soon as your Base Balance is over $%threshold% you qualify for an investment account. For more information, please visit our website.",
"pdf-statement-product-summary"                 : "%product% Summary",
"pdf-statement-account-start-date"              : "Account Start Date",
"pdf-statement-account-effective-date"          : "Account Effective Date",
"pdf-statement-rollover-prior-year"             : "Rollover from Prior Year",
"pdf-statement-beginning-balance"               : "Beginning Balance",
"pdf-statement-account-end-date"                : "Account End Date",
"pdf-statement-election-amount"                 : "Election Amount",
"pdf-statement-grace-period-end"                : "Grace Period End Date",
"pdf-statement-employer-funding"                : "Employer Funding",
"pdf-statement-claims-filing-deadline"           : "Claims Filing Deadline",
"pdf-statement-contributions"                   : "Contributions",
"pdf-statement-contributions-current-tax-year"  : "Current Tax Year Contributions",
"pdf-statement-contributions-prior-tax-year"    : "Prior Tax Year Contributions",
"pdf-statement-investment-account-transfers"    : "Investment Account Transfers",
"pdf-statement-other-transfers"                 : "Other Transfers",
"pdf-statement-interest-earned"                 : "Interest Earned",
"pdf-statement-fees"                            : "Fees",
"pdf-statement-account-termination-date"        : "Account Termination Date",
"pdf-statement-withdrawals"                     : "Withdrawals",
"pdf-statement-threshold-amount"                : "Threshold Amount",
"pdf-statement-available-base-balance"          : "Available Base Balance",
"pdf-statement-accumulation-amount"             : "Accumulation Amount",
"pdf-footer-visit-website"                      : "Visit our website to:",
"pdf-footer-visit-website-maximize-benefits"     : "Maximize account benefits by easily and conveniently submitting your claims online.",
"pdf-footer-visit-website-view-transactions"    : "View all transactions associated with your account.",
"pdf-footer-visit-website-setup-direct-deposit" : "Set up direct deposit for faster claim reimbursements.",
"pdf-footer-notify-if-not-correct"              : "We are committed to maintaining complete and accurate information about you and your accounts. If you believe the information appearing on this statement is not correct, please notify us at:",

// Transactions
"pdf-transactions-header": "The following claims were processed against your account during this reporting period:",
"pdf-transactions-date": "Date",
"pdf-transactions-description": "Description",
"pdf-transactions-no-transactions-found": "No transactions.",
"pdf-transactions-posted-transactions": "Posted Transactions",
"pdf-transactions-transactions": "All Transactions",
"pdf-transactions-type": "Type",
"pdf-transaction-detail-service-date": "Service Date",
"pdf-transaction-detail-service-dates": "Service Dates",
"pdf-transaction-detail-claim-details": "Claim Details",
"pdf-transaction-detail-claim-number": "Claim Number",
"pdf-transaction-detail-paid-amount": "Paid Amount",
"pdf-transaction-detail-denial-reason": "Denial Reason",
"pdf-transaction-detail-denied-amount": "Denied Amount",
"pdf-transaction-detail-process-date": "Process Date",
}